import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Sidebar from '../../components/ui/Sidebar';
import Breadcrumb from '../../components/ui/Breadcrumb';
import LifecyclePipelineView from '../asset-management-dashboard/components/LifecyclePipelineView';
import axios from '../../utils/axios';

const AssetLifecycle = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [users, setUsers] = useState([]);
  const [categories, setCategories] = useState([]);
  const [assets, setAssets] = useState([]);
  const [softwareLicences, setSoftwareLicences] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchMetadata = async () => {
      try {
        setLoading(true);
        const [usersRes, catRes, assetsRes, licRes] = await Promise.allSettled([
          axios.get('/admin/users'),
          axios.get('/asset-categories'),
          axios.get('/assets'),
          axios.get('/software-licences'),
        ]);

        if (usersRes.status === 'fulfilled') {
          const u = usersRes.value.data;
          setUsers(Array.isArray(u) ? u : (u?.data || []));
        }

        if (catRes.status === 'fulfilled') {
          const c = catRes.value.data;
          setCategories(Array.isArray(c) ? c : (c?.data || []));
        }

        if (assetsRes.status === 'fulfilled') {
          const a = assetsRes.value.data;
          setAssets(Array.isArray(a?.data) ? a.data : []);
        }

        if (licRes.status === 'fulfilled') {
          const body = licRes.value.data;
          const rows = Array.isArray(body) ? body : (Array.isArray(body?.data) ? body.data : []);
          setSoftwareLicences(rows);
        }
      } catch (err) {
        console.error('Error fetching metadata for lifecycle page:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchMetadata();
  }, []);

  return (
    <div className="flex h-screen bg-background overflow-hidden">
      <Helmet>
        <title>Asset Lifecycle Pipeline | Kerol Systems</title>
      </Helmet>

      {/* Sidebar Navigation */}
      <Sidebar
        isCollapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
      />

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Top Header */}
        <Header />

        {/* Main Scrollable Body */}
        <main className="flex-1 overflow-y-auto p-4 md:p-6 lg:p-8 space-y-6">
          <Breadcrumb
            items={[
              { label: 'Home', path: '/' },
              { label: 'Asset Operations', path: '/asset-management-dashboard' },
              { label: 'Asset Lifecycle Pipeline' },
            ]}
          />

          <LifecyclePipelineView
            rawAssets={assets}
            users={users}
            categories={categories}
            softwareLicences={softwareLicences}
          />
        </main>
      </div>
    </div>
  );
};

export default AssetLifecycle;
